"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleGS = void 0;
const gs = require("..");
class ToggleGS extends gs.WrapperGS {
    constructor(el) {
        super(el);
        if (!this.hasClass(ToggleGS.TagClassName))
            throw new Error("Trying create ToggleGS from HTMLElement without specific class in classList");
        this.el.addEventListener('click', (e) => this.activeFlip());
    }
}
exports.ToggleGS = ToggleGS;
ToggleGS.TagClassName = 'gs-toggle';
gs.WrapperGS.ExtendComponentsByTagClass(ToggleGS);
//# sourceMappingURL=ToggleGS.js.map